var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowUpIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 10.691 12.517"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".arrow-up-icon_svg__cls-1{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:1.464px}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow-up-icon_svg__Group_121",
    "data-name": "Group 121",
    transform: "translate(-5.354 -4.315)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "arrow-up-icon_svg__Line_57",
    "data-name": "Line 57",
    className: "arrow-up-icon_svg__cls-1",
    transform: "translate(10.699 5.35)",
    d: "M0 0v11.482"
  }), /*#__PURE__*/React.createElement("path", {
    id: "arrow-up-icon_svg__Path_164",
    "data-name": "Path 164",
    className: "arrow-up-icon_svg__cls-1",
    d: "M186.4 267.828l4.828-4.828 4.828 4.828",
    transform: "translate(-180.528 -257.65)"
  }))));
}

export default __webpack_public_path__ + "f763f471451b6c3422ea0bfc5d129eeb.svg";
export { SvgArrowUpIcon as ReactComponent };